import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MwPerfectScrollBarDirective } from '@core/directives/perfect-scrollbar.directive';

import { SidebarId } from '../../layout.constants';
import { MwSidebarService } from '../sidebar/sidebar.service';
import { MwSidebarComponent } from './../sidebar/sidebar.component';
import { News } from './@models/news.model';
import { MwNewsDataService } from './@services/news-data.service';

@Component({
  selector: 'mw-news',
  templateUrl: 'news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class MwNewsComponent implements OnInit, OnDestroy {
  news: News[] = [];

  @ViewChild(MwPerfectScrollBarDirective, { static: true })
  perfectScrollbar: MwPerfectScrollBarDirective;

  private unsubscribeAll$ = new Subject<void>();
  private newsSidebar: MwSidebarComponent;

  constructor(
    private readonly service: MwNewsDataService,
    private readonly sidebarService: MwSidebarService
  ) {}

  ngOnInit(): void {
    this.subscribeToNewsSidebar();
    this.setupData();
    this.service.refreshNews();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }

  onCloseMenu(): void {
    this.closeNewsSidebar();
    this.service.increaseNewsViewsCounter();
  }

  private closeNewsSidebar(): void {
    if (!this.newsSidebar) {
      return;
    }
    this.newsSidebar.close();
  }

  private openNewsSidebar(): void {
    if (!this.newsSidebar) {
      return;
    }
    this.newsSidebar.open();
  }

  private setupData(): void {
    this.service.news$.subscribe((item) => {
      this.news = item;
      if (this.news.find((t) => t.showNewsSidebar)) {
        this.openNewsSidebar();
      }
    });
  }

  private subscribeToNewsSidebar(): void {
    this.sidebarService
      .getSidebar(SidebarId.News)
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((sidebar) => (this.newsSidebar = sidebar));
  }
}
